import angular from 'angular'

export function IcdCommissionsService($http, apexApiUrl) {
    'ngInject'
    const service = {
        createIcdCommissions: createIcdCommissions,
        retrieveIcdCommissions: retrieveIcdCommissions,
        updateIcdCommissions: updateIcdCommissions,
        deleteIcdCommissions: deleteIcdCommissions,
        createIcdCommissionsAsSingleTier: createIcdCommissionsAsSingleTier,
        retrieveIcdCommissionsAsSingleTier: retrieveIcdCommissionsAsSingleTier,
        updateIcdCommissionsAsSingleTier: updateIcdCommissionsAsSingleTier
    }

    return service;

    function retrieveIcdCommissions(icdCorporationID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "commission-policies",
            headers: {
                Accept: 'application/json'
            },
            params: { icdCorporationID: icdCorporationID }
        }).then(function (response) {
            return response.data;
        })
    }

    function createIcdCommissions(commissions) {
        const data = stripIcdCommissionTimezones(commissions);
        return $http({
            method: "POST",
            url: apexApiUrl + "commission-policies",
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data)
        })
    }

    function updateIcdCommissions(commissions) {
        const data = stripIcdCommissionTimezones(commissions);
        return $http({
            method: "PUT",
            url: apexApiUrl + "commission-policies",
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data)
        })
    }

    function deleteIcdCommissions(icdCommissions) {
        const data = stripIcdCommissionTimezones(icdCommissions);
        return $http({
            method: "DELETE",
            url: apexApiUrl + "commission-policies",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(data)
        });
    }

    /**
     * Return a copy of the commissions data with local timezone data stripped out
     * and converted to string.
     */
    function stripIcdCommissionTimezones(commissions) {
        return commissions.map(function (commission) {
            const res = angular.copy(commission);
            if (commission.ActiveStart) {
                res.ActiveStart = commission.ActiveStart.toString("yyyy-MM-dd");
            }
            if (commission.ActiveEnd) {
                res.ActiveEnd = commission.ActiveEnd.toString("yyyy-MM-dd");
            }
            return res;
        });
    }

    /**
     * Save the single-tier commission data using its underlying tiers to store the data.
     */
    function createIcdCommissionsAsSingleTier(icdCommissionsAsSingleTier) {
        for (let i = 0; i < icdCommissionsAsSingleTier.length; i++) {
            createTiersFromSingleTierIcdCommission(icdCommissionsAsSingleTier[i]);
        }
        return service.createicdCommissions(icdCommissionsAsSingleTier)
            .then(function (response) {
                // Convert the multi-tiered commission model into data that can be represented by a single row.
                return response.data.map(flattenIcdCommission);
            });
    }

    function retrieveIcdCommissionsAsSingleTier() {
        return retrieveIcdCommissions()
            .then(function (icdCommissions) {
                // Convert the multi-tiered commission model into data that can be represented by a single row.
                return icdCommissions.map(flattenIcdCommission);
            });
    }

    /**
     * Save the single-tier commission data using its underlying tiers to store the data.
     */
    function updateIcdCommissionsAsSingleTier(icdCommissionsAsSingleTier) {
        for (let i = 0; i < icdCommissionsAsSingleTier.length; i++) {
            createTiersFromSingleTierIcdCommission(icdCommissionsAsSingleTier[i]);
        }
        return updateIcdCommissions(icdCommissionsAsSingleTier);
    }

    /**
     * Aggregate the icd commission's set of tiers into a single top-level policy.
     */
    function flattenIcdCommission(icdCommission) {
        if (icdCommission.IcdCommissionTiers.length > 0) {
            const primaryTier = icdCommission.IcdCommissionTiers[0];
            icdCommission.DailyNCRThreshold = primaryTier.DailyNCRThreshold;
            icdCommission.TierRate = (icdCommission.IcdCommissionTiers.filter(function (tier) {
                return tier.DailyNCRThreshold < tier.EndAmount;
            })[0] || primaryTier).TierRate;
        }
        return icdCommission;
    }

    /**
     * Create a set of commission tiers from a commission policy that contains flat data.
     */
    function createTiersFromSingleTierIcdCommission(icdCommissionAsSingleTier) {
        if (icdCommissionAsSingleTier.IcdCommissionTiers.length > 0) {
            const primaryTier = icdCommissionAsSingleTier.IcdCommissionTiers[0];
            primaryTier.StartAmount = 0;
            primaryTier.EndAmount = 1000000;
            primaryTier.TierRate = icdCommissionAsSingleTier.TierRate;
            primaryTier.DailyNCRThreshold = icdCommissionAsSingleTier.DailyNCRThreshold;
            // Remove tiers beyond the first one.
            icdCommissionAsSingleTier.IcdCommissionTiers.splice(1);
        } else {
            icdCommissionAsSingleTier.IcdCommissionTiers = [{
                IsNew: true,
                TierNo: 1,
                StartAmount: 0,
                EndAmount: 1000000,
                TierRate: icdCommissionAsSingleTier.TierRate,
                DailyNCRThreshold: icdCommissionAsSingleTier.DailyNCRThreshold
            }]
        }
    }
}
